import React, { FC } from 'react';
import Text, { TextSize } from '@move-ui/text';
import { IMAGE_ADEVINTA_LOGO } from '../config';
import styles from './Footer.css';
import { useTranslation } from '../utils/translations';

const Copyright: FC = () => {
  const { translate } = useTranslation();
  return (
    <div className={styles.credit}>
      <img
        alt={translate('adevinta_alt_text')}
        src={IMAGE_ADEVINTA_LOGO}
        className={styles.logo}
        width={84}
        height={18}
      />
      <Text color="neutral-200" size={TextSize.XS} className={styles.copyright}>
        {translate('copyright')}
      </Text>
    </div>
  );
};

export default Copyright;
